import {
  FETCH_RELEASE_NOTES_STARTED,
  FETCH_RELEASE_NOTES_SUCCESS,
  FETCH_RELEASE_NOTES_FAILIED,
} from './types';
import initialState from './initialState';

function releaseNotesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_RELEASE_NOTES_STARTED:
      return {
        ...state,
        loading: true,
      };
    case FETCH_RELEASE_NOTES_SUCCESS:
      return {
        ...state,
        loading: false,
        releaseNotes: action.releaseNotes,
      };
    case FETCH_RELEASE_NOTES_FAILIED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}

export default releaseNotesReducer;
